import { __awaiter } from "tslib";
import { useGetFlightsFromQuery } from '@websky/graphql';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading, setState } from '../store/flightStatus/flightStatus';
const MapDataLoader = () => {
    const UPDATE_TIMEOUT_IN_MINUTES = 5;
    const { loading, data: flightsData, refetch } = useGetFlightsFromQuery({ variables: { daysAfter: 1 } });
    const [, setLastUpdate] = useState(null);
    const dispatch = useDispatch();
    let timer;
    const refetchIfTimeout = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield refetch({ daysAfter: 1 });
        setLoading(false);
    });
    useEffect(() => {
        if (!loading && (flightsData === null || flightsData === void 0 ? void 0 : flightsData.FlightStatus)) {
            setLastUpdate(new Date());
            timer = setInterval(refetchIfTimeout, 1000 * 60 * UPDATE_TIMEOUT_IN_MINUTES);
        }
    }, [loading, flightsData]);
    useEffect(() => {
        return () => clearInterval(timer);
    }, []);
    useEffect(() => {
        dispatch(setLoading(loading));
    }, [loading]);
    useEffect(() => {
        if (flightsData === null || flightsData === void 0 ? void 0 : flightsData.FlightStatus) {
            dispatch(setState(flightsData.FlightStatus));
        }
    }, [flightsData]);
    return null;
};
export default MapDataLoader;
